import { render, staticRenderFns } from "./JsonEditor.vue?vue&type=template&id=4f23d5a2&scoped=true&"
import script from "./JsonEditor.vue?vue&type=script&lang=js&"
export * from "./JsonEditor.vue?vue&type=script&lang=js&"
import style0 from "./JsonEditor.vue?vue&type=style&index=0&id=4f23d5a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f23d5a2",
  null
  
)

export default component.exports